import Box from '@mui/material/Box'
import type { BoxProps } from '@mui/material'

export const TextArea = ({ children, className, ...otherProps }: BoxProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
      className={className}
      {...otherProps}
    >
      {children}
    </Box>
  )
}
